import { ServiceIcon, SkeletonText, Text } from "@zapier/design-system";
import { App } from "@zapier/types";
import { ActionChip } from "@zapier/design-system-beta";
import getAppIconUrl from "./getAppIconUrl";
import styles from "./AppList.module.css";

export function AppList({
  apps,
  handleAppClick,
  isLoading,
  title,
}: {
  apps: App[];
  handleAppClick: (app: App) => void;
  isLoading?: boolean;
  title: string;
}) {
  return (
    <div>
      <div>
        <Text type="MinimalPrint2" color="TextWeakest">
          {title}
        </Text>
      </div>
      <div className={styles.appList}>
        {isLoading ? (
          <SkeletonText lines={3} size="body" textAlign="left" width="100%" />
        ) : (
          apps.map((app) => {
            return (
              <ActionChip key={app.id} onPress={() => handleAppClick(app)}>
                <ServiceIcon
                  alt={`${app.name} icon`}
                  hasBorder={false}
                  size={20}
                  hasWhiteBackground={false}
                  hasShadow={false}
                  serviceName={app.name}
                  src={getAppIconUrl(
                    app.currentImplementation?.id,
                    app?.images,
                    30,
                  )}
                />
                <span className={styles.truncateText}>{app.name}</span>
              </ActionChip>
            );
          })
        )}
      </div>
    </div>
  );
}
